export * from "./array";

/**
 * A function doing nothing
 */
export const noop = () => {};
